// ثبت Service Worker اپ کارکنان (AP-OFF-01 — C-AGENT-1551): Build تولید با ?shell=1 (Cache پوسته برای کار آفلاین)؛ محیط توسعه بدون Cache پوسته
// (Push همان اسکریپت را بی‌پارامتر ثبت می‌کند تا Vite و page.route آزمون‌ها دست نخورند).
export const SERVICE_WORKER_URL = import.meta.env.PROD ? '/sw.js?shell=1' : '/sw.js';

/** ثبت پوسته آفلاین در شروع اپ (فقط Build تولید). */
export function registerAppShell(): void {
  if (!import.meta.env.PROD || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  void navigator.serviceWorker.register(SERVICE_WORKER_URL, { scope: '/' }).catch(() => undefined);
}
